// extracted by mini-css-extract-plugin
export default {"title":"PrivacyPolicy_title__CUfSt"};